"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDivider = void 0;
const styles_1 = require("@material-ui/core/styles");
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const react_1 = __importDefault(require("react"));
exports.ZDivider = (props) => {
    const defaultMargin = 10, marginTop = props.marginTop === undefined ? defaultMargin : props.marginTop, marginBottom = props.marginBottom === undefined ? defaultMargin : props.marginBottom, DividerComponent = styles_1.styled(Divider_1.default)({
        marginTop: marginTop,
        marginBottom: marginBottom,
        height: 2
    });
    return react_1.default.createElement(DividerComponent, null);
};
//# sourceMappingURL=ZDivider.js.map